"use strict";

module.exports = function () {
      return Object.keys(this.opts.templates);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/templates-keys.js
// module id = 2186
// module chunks = 0